var _path, _g, _g2, _g3, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 636,
    height: 388,
    viewBox: "0 0 636 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M491 195C491 290.545 413.545 368 318 368C222.455 368 145 290.545 145 195C145 99.4547 222.455 22 318 22C413.545 22 491 99.4547 491 195Z",
    fill: "url(#paint0_linear_5161_11511)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5161_11511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.553 217.615H190.771V262H146.533V217.615H55.127V186.121L149.023 47.8398H190.771V182.459H216.553V217.615ZM146.533 182.459V146.131C146.533 140.076 146.777 131.287 147.266 119.764C147.754 108.24 148.145 101.551 148.438 99.6953H147.266C143.652 107.703 139.307 115.516 134.229 123.133L94.9707 182.459H146.533Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5161_11511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M580.553 217.615H554.771V262H510.533V217.615H419.127V186.121L513.023 47.8398H554.771V182.459H580.553V217.615ZM510.533 182.459V146.131C510.533 140.076 510.777 131.287 511.266 119.764C511.754 108.24 512.145 101.551 512.438 99.6953H511.266C507.652 107.703 503.307 115.516 498.229 123.133L458.971 182.459H510.533Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5161_11511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.547 196.92C392.547 234.322 386.395 262.008 374.09 279.977C361.883 297.945 343.035 306.93 317.547 306.93C292.84 306.93 274.188 297.652 261.59 279.098C249.09 260.543 242.84 233.15 242.84 196.92C242.84 159.127 248.943 131.295 261.15 113.424C273.357 95.4551 292.156 86.4707 317.547 86.4707C342.254 86.4707 360.906 95.8457 373.504 114.596C386.199 133.346 392.547 160.787 392.547 196.92ZM287.811 196.92C287.811 223.189 290.057 242.037 294.549 253.463C299.139 264.791 306.805 270.455 317.547 270.455C328.094 270.455 335.711 264.693 340.398 253.17C345.086 241.646 347.43 222.896 347.43 196.92C347.43 170.65 345.037 151.803 340.252 140.377C335.564 128.854 327.996 123.092 317.547 123.092C306.902 123.092 299.285 128.854 294.695 140.377C290.105 151.803 287.811 170.65 287.811 196.92Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M451 337.5C451 365.39 428.39 388 400.5 388C372.61 388 350 365.39 350 337.5C350 309.61 372.61 287 400.5 287C428.39 287 451 309.61 451 337.5Z",
    fill: "url(#paint1_linear_5161_11511)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M253 42C253 53.0457 244.046 62 233 62C221.954 62 213 53.0457 213 42C213 30.9543 221.954 22 233 22C244.046 22 253 30.9543 253 42Z",
    fill: "url(#paint2_linear_5161_11511)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5161_11511",
    x: 0.126953,
    y: 0.839844,
    width: 271.426,
    height: 324.16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5161_11511"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5161_11511",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5161_11511",
    x: 364.127,
    y: 0.839844,
    width: 271.426,
    height: 324.16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5161_11511"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5161_11511",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5161_11511",
    x: 187.84,
    y: 39.4707,
    width: 259.707,
    height: 330.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5161_11511"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5161_11511",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5161_11511",
    x1: 190.5,
    y1: 72.5,
    x2: 495.11,
    y2: 199.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88BC2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5161_11511",
    x1: 363.282,
    y1: 301.741,
    x2: 452.2,
    y2: 338.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88BC2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#BACE1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5161_11511",
    x1: 218.26,
    y1: 27.8381,
    x2: 253.475,
    y2: 42.4658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#C2D118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88BC2F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error404.17236588f2f39b39d6253e511e24eabd.svg";
export { ForwardRef as ReactComponent };